import type { IntlShape, MessageDescriptor } from 'react-intl';

/**
 * Bridge so non-React modules (rematch effects, stream handlers) can format
 * react-intl messages as plain strings, e.g. for toast copy where the
 * design-system error tracking only extracts string values.
 *
 * `HeidiIntlProvider` keeps `currentIntl` in sync with the active locale via
 * `CurrentIntlBridge`; when several providers mount (auxiliary WebViews), the
 * last one wins. Runtime react-intl imports are deliberately avoided here so
 * test suites with bespoke `jest.mock('react-intl', ...)` factories can reach
 * this module without extending their mocks.
 */
let currentIntl: IntlShape | null = null;

export const setCurrentIntl = (intl: IntlShape | null): void => {
  currentIntl = intl;
};

/**
 * Format a descriptor with the active locale, falling back to the English
 * `defaultMessage` until a provider has mounted (early boot, jest).
 */
export const formatMessageOutsideReact = (descriptor: MessageDescriptor): string => {
  if (currentIntl) {
    return currentIntl.formatMessage(descriptor);
  }
  return typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';
};
